export { default as PriceToPayCollapsible } from '@/features/pos/components/OrderFinalization/parts/BottomSheet/parts/PriceToPay/PriceToPayCollapsible'
export { default as PriceToPayStatic } from '@/features/pos/components/OrderFinalization/parts/BottomSheet/parts/PriceToPay/PriceToPayStatic'
